'use client';

import ArrowIcon from '@/components/ui/icons/arrow-icon';
import LocationIcon from '@/components/ui/icons/LocationIcon';
import { useTranslations } from 'next-intl';
import useShippingInfoStore from '@/store/shipping-info.store';

const ShippingAddress = () => {
  const t = useTranslations('common');

  const shippingMethod = useShippingInfoStore((state) => state.shippingMethod);
  const shippingAddress = useShippingInfoStore(
    (state) => state.shippingAddress
  );
  const setIsOpenShippingInfoModal = useShippingInfoStore(
    (state) => state.setIsOpenShippingInfoModal
  );

  // pick the right localized label
  const selectYourKey = !shippingMethod
    ? 'select_your'
    : shippingMethod === 'storepickup'
      ? 'select_your_storepickup'
      : shippingMethod === 'Homedelivery'
        ? 'select_your_delivery'
        : 'select_your';

  return (
    <div
      onClick={() => setIsOpenShippingInfoModal(true)}
      className='flex cursor-pointer items-center gap-1.25 text-[#141414] max-sm:-mt-2'
    >
      <div className='flex size-7 items-center justify-center rounded-2xl bg-[#F2F3F5] lg:size-8'>
        <LocationIcon className='text-primary size-[14px]' />
      </div>
      <div className='flex flex-col'>
        <span className='text-xs font-medium'>{t(selectYourKey)}</span>
        <span className='flex items-center gap-2 text-sm font-semibold'>
          <span className='max-sm:text-md line-clamp-1 max-w-40 text-sm'>
            {shippingAddress?.street?.[0] ||
              t(shippingMethod || 'select_shipping_method_key')}
          </span>
          <ArrowIcon className='mx-1 size-2 lg:size-2.5' />
        </span>
      </div>
    </div>
  );
};

export default ShippingAddress;
